import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import '@/App.css';
import LandingPage from './components/LandingPage';
import HealthIntakeForm from './components/HealthIntakeForm';
import { PreviewRoute, PreviewProvider } from './components/preview/PreviewShell';
import ConciergeOtoPreview from './components/intake/ConciergeOtoPreview';
import SermorelinForm from './components/SermorelinForm';
import AntiAgingForm from './components/AntiAgingForm';
import FollowUpForm from './components/FollowUpForm';
import TrtForm from './components/TrtForm';
import WomenSexualHealthForm from './components/WomenSexualHealthForm';
import MensSexualHealthForm from './components/MensSexualHealthForm';
import BrandedWeightlossForm from './components/BrandedWeightlossForm';
import LabAuthorizationForm from './components/LabAuthorizationForm';
import LabAnalysisForm from './components/LabAnalysisForm';
import AdvancedPeptideForm, { AdvancedWeightLossForm, AdvancedLongevityForm } from './components/AdvancedPeptideForm';
import PharmacySmokeStep from './components/PharmacySmokeStep';
import { TenantBrandingProvider } from '@/context/TenantBranding';


// Flow key → live form, for /preview/:flow (see components/preview/PreviewShell).
const PREVIEW_FORMS = {
  glp1: HealthIntakeForm,
  branded: BrandedWeightlossForm,
  sermorelin: SermorelinForm,
  antiAging: AntiAgingForm,
  trt: TrtForm,
  wsh: WomenSexualHealthForm,
  msh: MensSexualHealthForm,
  labPanel: LabAuthorizationForm,
  labAnalysis: LabAnalysisForm,
  advancedPeptide: AdvancedPeptideForm,
  advancedWeightLoss: AdvancedWeightLossForm,
  advancedLongevity: AdvancedLongevityForm,
};

function App() {
  return (
    <Router>
      <TenantBrandingProvider>
      <div className="App">
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/glp1" element={<PreviewProvider flow="glp1"><HealthIntakeForm /></PreviewProvider>} />
          {/* §preview: the omzo-style presentation is the default on every live route above
              (incl. tenant-keyed links); /preview/<flow> stays as an alias for review links. */}
          <Route path="/preview/:flow" element={<PreviewRoute forms={PREVIEW_FORMS} />} />
          <Route path="/glp1-preview" element={<Navigate to="/preview/glp1" replace />} />
          <Route path="/sermorelin" element={<PreviewProvider flow="sermorelin"><SermorelinForm /></PreviewProvider>} />
          <Route path="/anti-aging" element={<PreviewProvider flow="antiAging"><AntiAgingForm /></PreviewProvider>} />
          <Route path="/trt" element={<PreviewProvider flow="trt"><TrtForm /></PreviewProvider>} />
          <Route path="/womens-sexual-health" element={<PreviewProvider flow="wsh"><WomenSexualHealthForm /></PreviewProvider>} />
          <Route path="/mens-sexual-health" element={<PreviewProvider flow="msh"><MensSexualHealthForm /></PreviewProvider>} />
          <Route path="/branded-weight-loss" element={<PreviewProvider flow="branded"><BrandedWeightlossForm /></PreviewProvider>} />
          {/* §branded-product-links — one entry point per product. The form reads
              :slug and narrows the catalog to that product; an unknown or
              not-yet-live slug falls through to the all-products door below. */}
          <Route path="/branded/:slug" element={<PreviewProvider flow="branded"><BrandedWeightlossForm /></PreviewProvider>} />
          {/* MANDATORY, not a courtesy. Vercel's CRA preset serves the SPA shell
              at any path depth, so nothing here ever 404s — without this route a
              typo'd or retired link renders HTTP 200 and a BLANK WHITE PAGE,
              which is strictly harder for a clinic to diagnose than a 404.
              Redirecting sends them to a working intake instead. */}
          <Route path="/branded" element={<Navigate to="/branded-weight-loss" replace />} />
          <Route path="/branded/*" element={<Navigate to="/branded-weight-loss" replace />} />
          <Route path="/lab-panel" element={<PreviewProvider flow="labPanel"><LabAuthorizationForm /></PreviewProvider>} />
          <Route path="/lab-analysis" element={<PreviewProvider flow="labAnalysis"><LabAnalysisForm /></PreviewProvider>} />
          {/* §advanced-peptide: non-Beluga async-telehealth intake (Dr. Mavroson), $299/mo membership. */}
          <Route path="/advanced-peptide" element={<PreviewProvider flow="advancedPeptide"><AdvancedPeptideForm /></PreviewProvider>} />
          <Route path="/advanced-weight-loss" element={<PreviewProvider flow="advancedWeightLoss"><AdvancedWeightLossForm /></PreviewProvider>} />
          <Route path="/advanced-longevity" element={<PreviewProvider flow="advancedLongevity"><AdvancedLongevityForm /></PreviewProvider>} />
          {/* §concierge-oto: design preview of the post-payment one-time offer (inert buttons, no visit, no backend). */}
          <Route path="/concierge-offer-preview" element={<ConciergeOtoPreview />} />
          <Route path="/test-pharmacy" element={<PharmacySmokeStep />} />
          <Route path="/followup" element={<FollowUpForm />} />
        </Routes>
      </div>
      </TenantBrandingProvider>
    </Router>
  );
}

export default App;
